<app-side-nav class="container-size"></app-side-nav>

<section class="privacy-page">
  <section [class.is-right]="isRight">
    <img
      class="mobile-back-to-main"
      src="assets/img/icons/contact/mobile_arrow_back.svg"
      alt="Zurück zur Startseite"
      role="button"
      tabindex="0"
      (click)="backToMain()"
      (keydown.enter)="backToMain()"
      (keydown.space)="backToMain()"
    />
    <section class="privacy" id="privacy-left">
      <div class="privacy-position">
        <div class="privacy-sideline-container">
          <h1 class="header-txt">{{ "privacy.title" | translate }}</h1>
        </div>
        <div class="privacy-txt-container">
          <div class="privacy-section">
            <h2>{{ "privacy.preamble_heading" | translate }}</h2>
            <p>{{ "privacy.preamble_p1" | translate }}</p>
            <p>{{ "privacy.preamble_p2" | translate }}</p>
            <p>{{ "privacy.preamble_status" | translate }}</p>
          </div>
          <div class="privacy-section">
            <h2>{{ "privacy.controller_heading" | translate }}</h2>
            <p>
              {{ "privacy.controller_name" | translate }}<br />
              {{ "privacy.controller_street" | translate }}<br />
              {{ "privacy.controller_city" | translate }}
            </p>
            <p>E-Mail: ebubekir.elicora&#64;gmx.de</p>
          </div>
          <div class="privacy-section">
            <h2>{{ "privacy.overview_heading" | translate }}</h2>
            <p>{{ "privacy.overview_intro" | translate }}</p>
            <h3>{{ "privacy.overview_types_heading" | translate }}</h3>
            <ul>
              <li>{{ "privacy.overview_types_1" | translate }}</li>
              <li>{{ "privacy.overview_types_2" | translate }}</li>
              <li>{{ "privacy.overview_types_3" | translate }}</li>
              <li>{{ "privacy.overview_types_4" | translate }}</li>
              <li>{{ "privacy.overview_types_5" | translate }}</li>
              <li>{{ "privacy.overview_types_6" | translate }}</li>
            </ul>
            <h3>{{ "privacy.overview_subjects_heading" | translate }}</h3>
            <ul>
              <li>{{ "privacy.overview_subjects_1" | translate }}</li>
              <li>{{ "privacy.overview_subjects_2" | translate }}</li>
              <li>{{ "privacy.overview_subjects_3" | translate }}</li>
              <li>{{ "privacy.overview_subjects_4" | translate }}</li>
              <li>{{ "privacy.overview_subjects_5" | translate }}</li>
            </ul>
            <h3>{{ "privacy.overview_purposes_heading" | translate }}</h3>
            <ul>
              <li>{{ "privacy.overview_purposes_1" | translate }}</li>
              <li>{{ "privacy.overview_purposes_2" | translate }}</li>
              <li>{{ "privacy.overview_purposes_3" | translate }}</li>
              <li>{{ "privacy.overview_purposes_4" | translate }}</li>
              <li>{{ "privacy.overview_purposes_5" | translate }}</li>
              <li>{{ "privacy.overview_purposes_6" | translate }}</li>
            </ul>
          </div>
          <div class="privacy-section">
            <h2>{{ "privacy.legal_basis_heading" | translate }}</h2>
            <p>{{ "privacy.legal_basis_intro" | translate }}</p>
            <ul>
              <li>{{ "privacy.legal_basis_1" | translate }}</li>
              <li>{{ "privacy.legal_basis_2" | translate }}</li>
              <li>{{ "privacy.legal_basis_3" | translate }}</li>
              <li>{{ "privacy.legal_basis_4" | translate }}</li>
            </ul>
            <p>{{ "privacy.legal_basis_national" | translate }}</p>
          </div>
          <div class="privacy-section">
            <h2>{{ "privacy.security_heading" | translate }}</h2>
            <p>{{ "privacy.security_p1" | translate }}</p>
            <p>{{ "privacy.security_p2" | translate }}</p>
            <p>{{ "privacy.security_tls" | translate }}</p>
          </div>
        </div>
      </div>
      <img
        class="next-arrow"
        src="assets/img/icons/arrows/arrow_right.png"
        alt="Weiter"
        role="button"
        tabindex="0"
        (click)="goRight()"
        (keydown.enter)="goRight()"
        (keydown.space)="goRight()"
      />
    </section>
    <section class="privacy privacy-right" id="privacy-right">
      <div class="privacy-position-right">
        <div class="privacy-txt-container">
          <div class="privacy-section">
            <h2>{{ "privacy.intl_heading" | translate }}</h2>
            <p>{{ "privacy.intl_p1" | translate }}</p>
            <p>{{ "privacy.intl_p2" | translate }}</p>
            <p>{{ "privacy.intl_p3" | translate }}</p>
          </div>
          <div class="privacy-section">
            <h2>{{ "privacy.storage_heading" | translate }}</h2>
            <p>{{ "privacy.storage_p1" | translate }}</p>
            <p>{{ "privacy.storage_p2" | translate }}</p>
            <p>{{ "privacy.storage_p3" | translate }}</p>
          </div>
          <div class="privacy-section">
            <h2>{{ "privacy.rights_heading" | translate }}</h2>
            <p>{{ "privacy.rights_intro" | translate }}</p>
            <ul>
              <li>{{ "privacy.rights_1" | translate }}</li>
              <li>{{ "privacy.rights_2" | translate }}</li>
              <li>{{ "privacy.rights_3" | translate }}</li>
              <li>{{ "privacy.rights_4" | translate }}</li>
              <li>{{ "privacy.rights_5" | translate }}</li>
              <li>{{ "privacy.rights_6" | translate }}</li>
              <li>{{ "privacy.rights_7" | translate }}</li>
            </ul>
          </div>
          <div class="privacy-section">
            <h2>{{ "privacy.contact_heading" | translate }}</h2>
            <p>{{ "privacy.contact_p1" | translate }}</p>
            <p>{{ "privacy.contact_p2" | translate }}</p>
            <p>{{ "privacy.contact_p3" | translate }}</p>
          </div>
          <div class="privacy-section">
            <h2>{{ "privacy.social_heading" | translate }}</h2>
            <p>{{ "privacy.social_p1" | translate }}</p>
            <p>{{ "privacy.social_p2" | translate }}</p>
            <p>{{ "privacy.social_p3" | translate }}</p>
            <p>{{ "privacy.social_p4" | translate }}</p>
          </div>
          <div class="privacy-section">
            <h2>{{ "privacy.whistle_heading" | translate }}</h2>
            <p>{{ "privacy.whistle_p1" | translate }}</p>
            <p>{{ "privacy.whistle_p2" | translate }}</p>
          </div>
          <div class="privacy-section">
            <h2>{{ "privacy.changes_heading" | translate }}</h2>
            <p>{{ "privacy.changes_p1" | translate }}</p>
            <p>{{ "privacy.changes_p2" | translate }}</p>
          </div>
          <div class="privacy-section">
            <h2>{{ "privacy.definitions_heading" | translate }}</h2>
            <p>{{ "privacy.definitions_intro" | translate }}</p>
            <ul>
              <li>{{ "privacy.definitions_1" | translate }}</li>
              <li>{{ "privacy.definitions_2" | translate }}</li>
              <li>{{ "privacy.definitions_3" | translate }}</li>
              <li>{{ "privacy.definitions_4" | translate }}</li>
              <li>{{ "privacy.definitions_5" | translate }}</li>
              <li>{{ "privacy.definitions_6" | translate }}</li>
            </ul>
          </div>
          <p class="seal">
            <a
              [href]="'privacy.seal_link' | translate"
              target="_blank"
              rel="noopener noreferrer nofollow"
            >
              {{ "privacy.seal_text" | translate }}
            </a>
          </p>
        </div>
      </div>
      <section class="info-side">
        <ul class="contacts">
          <li>
            <div class="email-container">
              <img
                class="emailImg"
                src="assets/img/icons/contact/eMail_contact.svg"
                alt="E-Mail Icon"
              />
              <a class="emailLink" href="mailto:ebubekir.elicora@gmx.de">
                E-Mail: ebubekir.elicora&#64;gmx.de
              </a>
            </div>
          </li>
          <li>
            <div class="phone-container">
              <img
                class="phoneImg"
                src="assets/img/icons/contact/phone_contact.svg"
                alt="Telefon Icon"
              />
              <a class="phoneLink" href="tel:+491714155340">
                Tel: 0171 4155340
              </a>
            </div>
          </li>
        </ul>

        <div class="container-privacy-notice">
          <div class="privacy-notice-pos">
            <a class="privacy-a" routerLink="/legal">
              {{ "contact.footer.legal" | translate }}
            </a>
            <a
              class="privacy-policy-a"
              routerLink="/privacy"
              (click)="onPrivacyClick()"
            >
              {{ "contact.footer.policy" | translate }}
            </a>
            <p>&copy; Ebubekir Elicora 2025</p>
          </div>
        </div>
      </section>
      <img
        class="back-arrow"
        src="assets/img/icons/arrows/arrow_left.png"
        alt="Zurück"
        role="button"
        tabindex="0"
        (click)="goLeft()"
        (keydown.enter)="goLeft()"
        (keydown.space)="goLeft()"
      />
      <div class="privacy-accent-layer">
        <div class="accent-bar" aria-hidden="true"></div>
      </div>
    </section>
    <section class="privacy-bottom-section mobile-container">
      <div class="mobile-size">
        <div class="social-container mobile-arrow">
          <img
            class="back-arrow-mobile"
            src="assets/img/icons/arrows/arrow_left.png"
            alt="Nach oben"
            role="button"
            tabindex="0"
            (click)="scrollToTopMobile()"
            (keydown.enter)="scrollToTopMobile()"
            (keydown.space)="scrollToTopMobile()"
          />
        </div>

        <nav class="mobile-social" aria-label="social">
          <div class="top-links">
            <a
              href="https://github.com/DEIN_GITHUB"
              target="_blank"
              rel="noopener"
              aria-label="GitHub"
              class="icon"
            >
              <img
                class="base"
                src="assets/img/icons/social_media/gitHub.svg"
                alt="GitHub"
              />
              <img
                class="hover"
                src="assets/img/icons/social_media/gitHub_hover.svg"
                alt=""
                aria-hidden="true"
              />
            </a>
            <a href="mailto:you@example.com" aria-label="E-Mail" class="icon">
              <img
                class="base"
                src="assets/img/icons/social_media/eMail.svg"
                alt="Mail"
              />
              <img
                class="hover"
                src="assets/img/icons/social_media/eMail_hover.svg"
                alt=""
                aria-hidden="true"
              />
            </a>
            <a
              href="https://www.linkedin.com/in/DEIN_LINKEDIN"
              target="_blank"
              rel="noopener"
              aria-label="LinkedIn"
              class="icon"
            >
              <img
                class="base"
                src="assets/img/icons/social_media/linkedIn.svg"
                alt="LinkedIn"
              />
              <img
                class="hover"
                src="assets/img/icons/social_media/linkedIn_hover.svg"
                alt=""
                aria-hidden="true"
              />
            </a>
          </div>
        </nav>
      </div>
      <div class="container-privacy-notice mobile-privacy">
        <div class="brand">
          <a
            class="brand-hit nav-link"
            href="#about"
            [attr.aria-label]="'nav.brand_about_aria' | translate"
          ></a>
          <svg
            class="brand-arc"
            viewBox="0 0 160 110"
            width="140"
            height="110"
            aria-hidden="true"
          >
            <path
              id="brandArcPath"
              d="M 20 90 A 62 100 0 0 1 140 90"
              fill="none"
            />
            <text class="brand-arc-text">
              <textPath
                href="#brandArcPath"
                startOffset="50%"
                text-anchor="middle"
                letter-spacing="-1"
              >
                {{ "nav.brand_arc" | translate }}
              </textPath>
            </text>
          </svg>
          <h1>EE</h1>
        </div>
        <div class="privacy-notice-pos">
          <p>&copy; Ebubekir Elicora 2025</p>
          <div class="privacy-policy-mobile-container">
            <a class="privacy-a" routerLink="/legal">
              {{ "contact.footer.legal" | translate }}
            </a>
            <a
              class="privacy-policy-a"
              routerLink="/privacy"
              (click)="onPrivacyClick()"
            >
              {{ "contact.footer.policy" | translate }}
            </a>
          </div>
        </div>
      </div>
    </section>
  </section>
</section>
